import { useI18n } from 'vue-i18n';

export default {
    setup() {
        const { t } = useI18n();
        return {
            t
        }
    },
    props: {
        size: {
            type: String
        },
        title: {
            type: String
        },
        message: {
            type: String
        },
        primaryBtn: {
            type: Object
        },
        secondaryBtn: {
            type: Object
        },
        closeModalCallback: {
            required: false,
            type: Function
        },
        modifyQuotationCart: {
            type: String
        }
    }
}